import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBot$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBot extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-bot", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.5993 11.5993C15.5933 11.5993 16.3992 12.4051 16.3992 13.3992V14.1233C16.3992 14.9982 16.0173 15.8295 15.3534 16.3994C14.1011 17.4746 12.3089 18 9.99696 18C7.68543 18 5.89442 17.4747 4.64417 16.3998C3.98129 15.8299 3.59998 14.9992 3.59998 14.125V13.3992C3.59998 12.4051 4.40584 11.5993 5.39992 11.5993H14.5993ZM14.5993 12.7992H5.39992C5.06856 12.7992 4.79994 13.0679 4.79994 13.3992V14.125C4.79994 14.6496 5.02873 15.148 5.42646 15.4899C6.43289 16.3552 7.94966 16.8 9.99696 16.8C12.0449 16.8 13.5631 16.3549 14.5718 15.4889C14.9701 15.147 15.1992 14.6482 15.1992 14.1233V13.3992C15.1992 13.0679 14.9306 12.7992 14.5993 12.7992ZM9.91581 2.00548L9.99722 2C10.301 2 10.552 2.22572 10.5917 2.51857L10.5972 2.59998L10.5966 3.19917L13.3969 3.19957C14.3909 3.19957 15.1968 4.00543 15.1968 4.99952V8.60309C15.1968 9.59717 14.3909 10.403 13.3969 10.403H6.59706C5.60297 10.403 4.79711 9.59717 4.79711 8.60309V4.99952C4.79711 4.00543 5.60297 3.19957 6.59706 3.19957L9.39661 3.19917L9.39724 2.59998C9.39724 2.29623 9.62296 2.04521 9.91581 2.00548L9.99722 2L9.91581 2.00548ZM13.3969 4.39954H6.59706C6.26569 4.39954 5.99707 4.66816 5.99707 4.99952V8.60309C5.99707 8.93445 6.26569 9.20307 6.59706 9.20307H13.3969C13.7282 9.20307 13.9968 8.93445 13.9968 8.60309V4.99952C13.9968 4.66816 13.7282 4.39954 13.3969 4.39954ZM8.19644 5.5995C8.7484 5.5995 9.19584 6.04695 9.19584 6.5989C9.19584 7.15086 8.7484 7.59831 8.19644 7.59831C7.64449 7.59831 7.19704 7.15086 7.19704 6.5989C7.19704 6.04695 7.64449 5.5995 8.19644 5.5995ZM11.7905 5.5995C12.3425 5.5995 12.7899 6.04695 12.7899 6.5989C12.7899 7.15086 12.3425 7.59831 11.7905 7.59831C11.2386 7.59831 10.7911 7.15086 10.7911 6.5989C10.7911 6.04695 11.2386 5.5995 11.7905 5.5995Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-bot-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-bot", "wpp-icon-bot-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-bot-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-bot-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBot$1);
      }
      break;
  } });
}

const WppIconBot = WppIconBot$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBot, defineCustomElement };
